module.exports = __webpack_public_path__ + "static/media/new-bharatpe-logo.26f32cec.jpeg";